import { UserOrigin } from '@/client/users/types/origins.enum';

export const isManualLoginOrigin = (
  origin?: UserOrigin | string | null,
): boolean => origin === UserOrigin.MANUAL;
